<template>
  <div class="container">
    <div class="row">
      <div class="col-11 pl-0 bg-white ln-darkblue ln-subtitle-text-thin" id="found_text">
        Rasta: <span class="ln-subtitle-text">{{ documentCount }}</span>
      </div>
      <div v-if="isExcelExportEnabled" class="col-1 text-right m-0 p-0">
        <button
          type="button"
          class="btn ln-bnt-secondary-outline m-0"
          @click="exportResultsExcel()"
          aria-label="Eksportuoti rezultatus į Excel"
        >
          <i class="fas fa-file-excel" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="ln-bt-g mt-3" style="margin-right: -15px; margin-left: -15px"></div>
    <div class="row">
      <div class="bg-white" colspan="2">
        <table role="presentation">
          <tr v-for="(item, index) in listItems" :key="index">
            <td class="align-text-top font-weight-bold pr-2 pt-4">
              {{ itemIndex(index) }}.
            </td>
            <td class="pt-4">
              <div>
                <router-link
                  class="ln-primary ln-subtitle-text-thin"
                  :to="{ name: 'document', params: { id: item.id } }"
                >
                  {{ item.title }}
                </router-link>
              </div>
              <div>
                <span class="ln-bckg-darkblue ln-sm-text-bold pr-2 pl-2">{{ item.regNr }}</span>
                <span class="ln-sm-text pl-2 ln-darkblue">{{ item.signDate }}</span>
              </div>
              <div>
                <span class="ln-sm-text ln-darkblue">
                  {{ item.organization ? fixCapitalization(item.organization) : "" }},
                </span>
                <span class="ln-sm-text-bold pl-2 ln-darkblue">{{ item.name }}</span>
              </div>
              <div class="ln-sm-text-bold ln-darkblue">
                <font-awesome-icon
                  style="width: 0.5em; margin-right: 0.3em"
                  :class="'ln-sviesoforas-' + item.statusCode.toLowerCase()"
                  icon="circle"
                  aria-hidden="true"
                />
                <span class="ln-status-name-container" data-testid="status-name">{{ getStatusName(item) }}</span>
              </div>

              <!-- Publikacijos -->
              <div v-if="isPublicationsDisplayInSearchResultsEnabled">
                <b-spinner
                  v-if="!item.publicationsLoaded"
                  variant="primary"
                  style="width: 0.5em; height: 0.5em; margin-left: 2px"
                ></b-spinner>
                <div
                  v-if="item.publicationsLoaded && item.publications && item.publications.length > 0"
                  class="d-flex mt-1"
                >
                  <div class="ln-sm-text-bold ln-darkblue">Publikacijos:</div>
                  <div class="ml-2">
                    <div
                      v-for="(publication, pubIndex) in item.publications"
                      :key="pubIndex"
                      class="ln-sm-text"
                    >
                      <span class="ln-sm-text ln-darkblue">{{ publication.name }}</span>
                      <span class="ln-sm-text ln-darkblue">, Data: {{ publication.publ_date.slice(0, 10) }}</span>
                      <span class="ln-sm-text ln-darkblue">, Publikacijos Nr.: {{ publication.publ_nr }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <document-category :categories="item.categories" :interactive="true" @searchEvent="$emit('searchEvent', $event)" />
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { normalizeCapitalization } from "../../_Services/repository";
import { GetDocumentList, GetDocumentCategories } from "../../Assets/repository";
import { utils, writeFile } from "xlsx";
import DocumentCategory from './document-category.vue';

export default {
  name: "list-body",
  components: {
    DocumentCategory
  },
  props: {
    documentList: Object,
    currentPage: Number,
    resultPerPage: Number,
  },
  async created() {
    if (this.documentList && this.documentList.items && this.documentList.items.length) {
      const documentIds = this.documentList.items.map(item => item.id);
      try {
        const data = await this.fetchDocumentCategories(documentIds);
        const categoriesByDocument = this.groupCategoriesByDocument(data);
        this.documentList.items.forEach(item => {
          const categories = categoriesByDocument[item.id] || [];
          const enhancedCategories = categories.map(cat => ({
            ...cat,
            expanded: false
          }));
          this.$set(item, 'categories', enhancedCategories);
        });
      } catch (error) {
        console.error('Klaida kraunant kategorijas:', error);
        this.documentList.items.forEach(item => {
          this.$set(item, 'categories', []);
        });
      }
    } else {
      this.documentList.items.forEach(item => {
        this.$set(item, 'categories', []);
      });
    }
  },
  methods: {
    async fetchDocumentCategories(documentIds) {
      try {
        const response = await GetDocumentCategories(documentIds);
        return response.data;
      } catch (error) {
        console.error('Klaida kraunant kategorijas:', error);
        throw error;
      }
    },
    groupCategoriesByDocument(apiData) {
      const map = {};
      apiData.forEach(item => {
        const docId = item.documentId;
        if (!map[docId]) {
          map[docId] = [];
        }
        let category = map[docId].find(cat => cat.categoryId === item.categoryId);
        if (!category) {
          category = {
            categoryId: item.categoryId,
            categoryName: item.categoryName,
            categoryRanking: item.categoryRanking,
            subCategories: [],
            expanded: false
          };
          map[docId].push(category);
        }
        if (item.subcategoryName && !category.subCategories.some(sc => sc.name === item.subcategoryName)) {
          category.subCategories.push({ 
            name: item.subcategoryName, 
            id: item.subcategoryId 
          });
        }
      });
      Object.values(map).forEach(categories => {
        categories.sort((a, b) => b.categoryRanking - a.categoryRanking);
      });
      return map;
    },
    itemIndex(index) {
      return (this.currentPage - 1) * this.resultPerPage + index + 1;
    },
    getStatusName(item) {
      switch (item.statusCode.toLowerCase()) {
        case "success":
          return "GALIOJA";
        case "warning":
          return "ĮSIGALIOJA";
        case "danger":
          return "NEGALIOJA";
        default:
          return item.statusName ? item.statusName.toUpperCase() : "";
      }
    },
    fixCapitalization(text) {
      return normalizeCapitalization(text);
    },
    exportResultsExcel() {
      const params = {
        ...this.$route.query,
        puslapis: this.currentPage,
        kiekis: this.resultPerPage,
      };
      params.kiekis = this.documentList.count;
      const queryString = new URLSearchParams(params).toString();
      GetDocumentList("?" + queryString)
        .then((response) => {
          const baseUrl = window.location.origin;
          const pres = JSON.parse(JSON.stringify(response.data.items)).map(item => ({
            ...item,
            documentLink: `${baseUrl}${process.env.VUE_APP_BASE_URL}document/${item.id}`
          }));
          const ws = utils.json_to_sheet(pres);
          const wb = utils.book_new();
          utils.book_append_sheet(wb, ws, "Data");
          writeFile(wb, "PaieskosRezultatai.xlsx");
        })
        .catch((error) => {
          console.error("Error fetching document list for export:", error);
        });
    },
  },
  mounted() {
    const element = document.getElementById("found_text");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  },
  computed: {
    documentCount() {
      return Math.ceil(this.documentList.count);
    },
    listItems() {
      return this.documentList.items;
    },
    isPublicationsDisplayInSearchResultsEnabled() {
      return process.env.VUE_APP_SEARCH_DISPLAY_PUBLICATIONS === "true";
    },
    isExcelExportEnabled() {
      return process.env.VUE_APP_EXCEL_EXPORT === "true";
    },
  },
};
</script>

<style scoped>
</style>